import { createFileRoute } from '@tanstack/react-router'

import Layout from '@/components/layout/baseLayout'
import Hero from '@/features/landingPage/components/hero'
import { NavBoxes } from '@/features/landingPage/navBoxes/navBoxes'

export const Route = createFileRoute('/')({
	component: App,
	head: () => ({
		// title: 'My App',
		// meta: [
		// 	{
		// 		title: 'MarketView',
		// 	},
		// ],
		// scripts: [
		// 	{
		// 		src: 'https://www.google-analytics.com/analytics.js',
		// 	},
		// ],
	}),
})

function App() {
	return (
		<Layout llmName="open-gateway-marketplace">
			<Hero />
			<NavBoxes />
		</Layout>
	)
}
